import React, { useState, useEffect, useCallback } from 'react';
import { useMapContext } from '../../_MapContext';
import StampUtils from '../../_StampUtils';
import ProximityManager from '../shared/ProximityManager';
import ARService from '../../services/ARService';
import { debug } from '../../_DebugLog';
import { useLang } from '../../_LangContext';

const ARButton = ({ data, lang }) =>
{
    const [arEnabled, setArEnabled] = useState(false);
    const { gpsCheckEnabled } = useMapContext();
    const [proximityManager] = useState(() => new ProximityManager());
    const { getText } = useLang();

    const gainStamp = useCallback(() => 
    {
        if (data?.id) 
        {
            const gained = StampUtils.gainStamp(data.id);
            if (gained) 
            {
                debug.log('Gained new stamp for building:', data.id);
            }
        }
    },
    [data]);

    const handleARClick = useCallback(() => 
    {
        if (!arEnabled) return;
        
        const success = ARService.openAR(data.id, lang, gainStamp);
        if (!success) 
        {
            console.warn('Failed to open AR for building:', data.id);
        }
    },
    [arEnabled, data, lang, gainStamp]);

    useEffect(() =>
    {
        // Check if building has AR using ARService
        const hasAR = ARService.hasAR(data?.id);
        
        if (hasAR && data)
        {
            const cleanup = proximityManager.setupProximityUpdates(
                data, 
                gpsCheckEnabled, 
                setArEnabled
            );

            return cleanup || (() => {});
        }
    },
    [data, gpsCheckEnabled, proximityManager]);

    // Check if building has AR using ARService
    const hasAR = ARService.hasAR(data?.id);
    if (!hasAR) return null;

    return (
        <div className="block ar-info">
            <button 
                className={`normal w-icon solid b-ar start-ar ${!arEnabled ? 'disabled' : ''}`} 
                onClick={handleARClick}
                disabled={!arEnabled}
            >
                <p className="icon ar"></p>
                <div className="btn-label">{getText('ar-start')}</div>
            </button>
        </div>
    );
};

export default ARButton; 